export default __webpack_public_path__ + "static/media/exclamanation.b45363a9.svg";